const activitypackagecourse = {
  getlist: 'activitypackagecourse/getlist',
  add: 'activitypackagecourse/add',
  update: 'activitypackagecourse/update',
  remove: 'activitypackagecourse/remove',
  get: 'activitypackagecourse/get-by-admin',
  getall: 'activitypackagecourse/getall',
  summary: 'activitypackagecourse/summary',
}
export default activitypackagecourse
